import { useState, useEffect } from "react";
import { fetchData } from "./fetchData"; // adjust path as needed

/**
 * Custom React hook for fetching page data from a JSON file.
 *
 * @param {string} pageName - The name of the page  to fetch (e.g., "JuniorTeen").
 * @returns {{ data: Object|null, loading: boolean }} - Returns the fetched data and a loading state.
 *
 * @example
 * const { data, loading } = usePageData("JuniorTeen");
 */
export default function usePageData(pageName) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchData(pageName, setData, setLoading);
    }, [pageName]);

    return { data, loading };
}